// Google Ads click IDs land in the URL of the ad-referred page and would be lost
// once the visitor navigates on. They're captured into a cookie on the shared
// root domain so the app (platform.foursource.com) can read them later at signup
// for ad attribution - see FS#314.
const CLICK_ID_PARAMS = ['gclid', 'gbraid', 'wbraid']
const COOKIE_DOMAIN = '.foursource.com'
const COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60 // Google Ads' longest click-through conversion window

export const captureClickIds = () => {
  const params = new URLSearchParams(window.location.search)

  CLICK_ID_PARAMS.forEach((param) => {
    const value = params.get(param)
    if (!value) return

    document.cookie = `${param}=${encodeURIComponent(value)}; Domain=${COOKIE_DOMAIN}; Path=/; Max-Age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax; Secure`
  })
}
